define('components/charts/tooltip',['google_charts!corechart'], function() {
    var $tooltip = $('<div id="jsq_chart_tooltip"></div>');
    var $tooltipTitle = $('<div class="jsq_chart_tooltip_title"></div>').appendTo($tooltip);
    var $tooltipBody = $('<div class="jsq_chart_tooltip_body"></div>').appendTo($tooltip);

    var delayHideTooltip = null;
    var delayRemoveTooltip = null;
    var delayShowTooltip = null;
    var tooltipShouldShow = false;
    var insideTooltip = false;

    $(window).on('mousemove', function(event) {
        if ($tooltip[0] == event.target || $.contains($tooltip[0], event.target)) {
            insideTooltip = true;
            clearTimeout(delayHideTooltip);
        } else if (tooltipShouldShow && !insideTooltip) {
            // stay
        } else {
            insideTooltip = false;
            chartsTooltipComponent.hideTooltip();
        }
    });

    var chartsTooltipComponent = {
        /**
        handlerConfig should be: {
            onlyHoverOnDataPoints: true,
            handler: function(row, column) {
                return {
                    title: '',
                    body: '',
                    targetX: 0,
                    targetY: 0,

                    // Optional, default `false`
                    assumeMouseInsideTooltip: false
                }
            }
        }
        **/
        setTooltipHandler: function(chart, handlerConfig) {
            var callHandler = function(row, column) {
                var tooltipConfig;
                if (handlerConfig.onlyHoverOnDataPoints && typeof row == 'number' && typeof column == 'number') {
                    tooltipConfig = handlerConfig.handler(row, column);
                } else if (!handlerConfig.onlyHoverOnDataPoints && typeof row == 'number') {
                    tooltipConfig = handlerConfig.handler(row, null);
                }
                
                if (tooltipConfig) {
                    chartsTooltipComponent.showTooltip(tooltipConfig.title, tooltipConfig.body, tooltipConfig.targetX, tooltipConfig.targetY, tooltipConfig.assumeMouseInsideTooltip);
                } else {
                    chartsTooltipComponent.hideTooltip();
                }
            };
            
            google.visualization.events.addListener(chart, 'onmouseover', function(event) {
                callHandler(event.row, event.column);
            });
        
            google.visualization.events.addListener(chart, 'onmouseout', function(event) {
                chartsTooltipComponent.hideTooltip();
            });
        },

        showTooltip: function(tooltipTitle, tooltipBody, targetX, targetY, assumeMouseInsideTooltip) {
            clearTimeout(delayRemoveTooltip);
            clearTimeout(delayHideTooltip);
            clearTimeout(delayShowTooltip);
            tooltipShouldShow = true;
            
            if (assumeMouseInsideTooltip) {
                insideTooltip = true;
            }
    
            delayShowTooltip = setTimeout(function() {
                var marginTop = 12;
                var marginLeft = 8;
                if (!$.contains(document.body, $tooltip[0])) {
                    $tooltip.appendTo('body');
                }
                $tooltipTitle.html(tooltipTitle || '');
                $tooltipBody.html(tooltipBody || '');
                var width = $tooltip.outerWidth()
                var height = $tooltip.outerHeight()
                $tooltip.css({
                    top: targetY - height - marginTop,
                    left: Math.max(marginLeft, targetX - width/2),
                })
                //delayAnimateTooltip = setTimeout(function(){
                    $tooltip.css({
                        opacity: 1,
                    });
                //}, 0);
            }, 0);
        },

        hideTooltip: function() {
            clearTimeout(delayRemoveTooltip);
            clearTimeout(delayHideTooltip);
            clearTimeout(delayShowTooltip);
            delayHideTooltip = setTimeout(function() {
                $tooltip.css({opacity:0});
                delayRemoveTooltip = setTimeout(function() {
                    tooltipShouldShow = false;
                    $tooltip.remove();
                }, 300);
            }, 700);
        }
    };

    return chartsTooltipComponent;
});

